const r = /* @__PURE__ */ (() => {
  const n = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  return () => n.replace(/[xy]/g, (t) => {
    const x = Math.random() * 16 | 0;
    return (t == "x" ? x : x & 3 | 8).toString(16);
  });
})();
export {
  r as default,
  r as uuid
};
